import { render } from "./CvMaker-form.vue?vue&type=template&id=2d6fd644"
import script from "./CvMaker-form.vue?vue&type=script&lang=js"
export * from "./CvMaker-form.vue?vue&type=script&lang=js"

import "./CvMaker-form.vue?vue&type=style&index=0&id=2d6fd644&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__